import axios from 'axios'
import { calls } from '../utils/calls.js'
import { createError } from '../utils/utils.js'

export const getUser = () => {
  return (dispatch) => {
    return axios(calls.getUserId())
      .then((res) => {
        let user = res.data

        dispatch({
          type: 'SET_USER',
          payload: { user: user },
        })
      })
      .catch((err) => {
        dispatch({
          type: 'SET_USER_REJECTED',
          payload: { err: createError(err) },
        })
      })
  }
}

export const getUserWithNoDispatch = () => {
  return axios(calls.getUserId()).then((res) => {
    let user = res.data
    return user
  })
}
